import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";
import type { HTMLAttributes, ReactNode } from "react";

type Skin = "info" | "grey";
export const ChipV2 = (
  props: {
    label: ReactNode;
    onDelete?: () => void;
    disabled?: boolean;
    skin?: Skin;
  } & HTMLAttributes<HTMLDivElement>,
) => {
  const {
    label,
    onDelete,
    onClick,
    disabled = false,
    skin = "info",
    ...restProps
  } = props;
  return (
    <div
      css={chipContainer({
        disabled,
        clickable: !!onClick && !disabled,
        skin,
      })}
      onClick={onClick}
      {...restProps}
    >
      <div css={labelContainer}>{label}</div>

      {!!onDelete && (
        <i
          onClick={(e) => {
            e.stopPropagation();
            if (disabled) {
              return;
            }
            onDelete?.();
          }}
          className={"icon-15-clear_x"}
          css={deleteIcon({
            disabled,
          })}
        />
      )}
    </div>
  );
};

const deleteIcon =
  ({ disabled }: { disabled: boolean }) =>
  (theme: ExactTheme) => css`
    color: ${theme.colorsV2[disabled ? "grey" : "blue"][500]};
    font-size: 15px;
    display: flex;
    align-items: center;
    padding: 5px;
    margin-right: -5px;
    :hover {
      color: ${theme.colorsV2[disabled ? "grey" : "red"][500]};
    }
  `;

const chipContainer =
  ({
    disabled,
    skin,
    clickable,
  }: {
    disabled: boolean;
    skin: Skin;
    clickable: boolean;
  }) =>
  (theme: ExactTheme) => {
    const getBorderColor = () => {
      if (disabled) {
        return theme.colorsV2["grey"][500];
      }
      if (skin === "info") {
        return theme.colorsV2["blue"][500];
      }
      return theme.colorsV2["grey"][200];
    };

    return css`
      height: 25px;
      cursor: ${disabled ? "not-allowed" : clickable ? "pointer" : "default"};
      padding: 0 10px;
      border-radius: 15px;
      border: 1px solid ${getBorderColor()};
      display: inline-flex;
      align-items: center;

      min-width: 0;
      :hover {
        background-color: ${disabled ? "transparent" : theme.colorsV2.grey[50]};
      }
    `;
  };

const labelContainer = (theme: ExactTheme) => css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
